function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _default = function () {
  function _default() {
    _classCallCheck(this, _default);

    this.operations = [];
  }

  _default.prototype.execute = function execute() {
    var _this = this;

    this.operations.reduce(function (queuePromise, operation) {
      return queuePromise.then(function () {
        // console.log('Operation queue', {executing: operation});
        return operation().then(function () {
          var operationIndex = _this.operations.indexOf(operation);
          if (operationIndex > -1) {
            _this.operations.splice(operationIndex, 1);
          }
        });
      });
    }, Promise.resolve()).then(function () {
      if (_this.operations.length > 0) {
        return _this.execute();
      }
    });
  };

  _default.prototype.add = function add(operation) {
    // console.log('Operation queue', { adding: operation });
    this.operations.push(operation);
  };

  return _default;
}();

export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/scandit-sdk-react/es/operation-queue.js
// module id = 1381
// module chunks = 0